import { useState } from "react";
import { faqs } from "@/mocks/kanliao";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100/70 py-16 md:py-24">
      <div className="container-px">
        <div className="mx-auto flex max-w-2xl flex-col items-center text-center">
          <span className="section-title">常见问题</span>
          <h2 className="heading mt-4">关于订阅提醒，你可能想问</h2>
          <p className="prose-p mt-4">
            我们把最常被问到的问题整理在这里。如果仍有疑问，欢迎通过页脚邮箱联系我们。
          </p>
        </div>

        <div className="mx-auto mt-12 max-w-3xl divide-y divide-background-200 rounded-2xl border border-background-200/70 bg-background-50 px-5 md:px-8">
          {faqs.map((faq, index) => {
            const isOpen = openIdx === index;
            return (
              <div key={faq.q} className="py-1">
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? -1 : index)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 py-5 text-left"
                >
                  <h3
                    className={`font-heading text-base font-bold md:text-lg ${
                      isOpen ? "text-primary-700" : "text-foreground-950"
                    }`}
                  >
                    {faq.q}
                  </h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen
                        ? "bg-primary-500 text-background-50"
                        : "bg-secondary-100 text-foreground-700"
                    }`}
                    aria-hidden="true"
                  >
                    <i
                      className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-lg`}
                    ></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="pb-6 text-sm leading-7 text-foreground-600">
                    {faq.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}